export default __webpack_public_path__ + "static/media/InterviewHistory.8c770ccd.svg";